import { exists } from '@/api'

export interface SystemConfig {
  id: number
  key: string
  note: string
  value: string
  revision: number
}

export function SystemConfigFromJSON(json: any): SystemConfig {
  return {
    id: exists(json, 'id') ? json.id : 0,
    key: exists(json, 'key') ? json.key : '',
    note: exists(json, 'note') ? json.note : '',
    value: exists(json, 'value') ? json.value : '',
    revision: exists(json, 'revision') ? json.revision : 1
  }
}

export function SystemConfigToJSON(value: SystemConfig): any {
  return {
    id: value.id,
    key: value.key,
    note: value.note,
    value: value.value,
    revision: value.revision
  }
}

export const defaultSystemConfig = (): SystemConfig => ({
  id: 0,
  key: '',
  note: '',
  value: '',
  revision: 1
})
